import React from "react";
import { TextLinkProps } from "../../types-interfaces/interfaces";
import { TextLinkAStyle, TextLinkStyle } from "../styles/MenuStyle";

class TextLink extends React.Component<TextLinkProps> {

  render() {
    return (
      <div
        {...this.props}
        style={(this.props.className) ? undefined : this.props.style ?? TextLinkStyle}
      >
        <a
          href={this.props.url}
          style={(this.props.className) ? undefined : this.props.linkstyle ?? TextLinkAStyle}
        >
            {this.props.text}            
        </a>
        {this.props.icon}
      </div>
    );
  }
}

export default TextLink;